import Vue from 'vue';
import VueRouter from 'vue-router';
import authPlugin from '../plugins/auth';
import store from '@/store';
import auth from './auth';
import dashboard from './dashboard';

Vue.use(VueRouter);

const routes = [...auth, ...dashboard];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

function getDefaultContext(path, userMenu) {
  const cleanPath = path.replace('/dashboard/', '');

  for (const module of userMenu) {
    const sections = module.sections || [];

    const match = sections.find((s) => s.path === cleanPath);

    if (match) {
      return {
        moduleId: match.module_id,
        sectionId: match.id,
      };
    }
  }

  return null;
}

router.beforeEach((to, from, next) => {
  const requiredAuth = to.matched.some((route) => route.meta.requiredAuth);
  const isAuthenticated = authPlugin.check();

  if (to.name === 'VerifyEmail') {
    return next();
  }

  if (requiredAuth && !isAuthenticated) {
    return next({ name: 'Login' });
  }

  if (!requiredAuth && isAuthenticated) {
    return next({ name: 'Dashboard' });
  }

  if (to.path.startsWith('/dashboard')) {
    const { moduleId, sectionId } = to.query;

    if (!moduleId || !sectionId) {
      const userMenu = store.getters.user?.menu;

      if (!userMenu || !userMenu.length) {
        return next();
      }

      const context = getDefaultContext(to.path, userMenu);

      if (context) {
        return next({
          path: to.path,
          query: {
            ...to.query,
            moduleId: context.moduleId,
            sectionId: context.sectionId,
          },
          replace: true,
        });
      }
    }
  }
  next();
});

export default router;
